import { FC, JSX, PropsWithChildren } from 'react';

import { ConfigProvider } from 'antd';

import { getAntdThemeConfig } from '@/components/layout/config-provider-wrapper/ConfigProviderWrapper.constants';

import useGetDefaultColorsMap from '@/hooks/useGetDefaultColorsMap';

type TDebtsTableConfigProps = PropsWithChildren<{
	children: React.ReactNode;
}>;

export const DebtsTableConfig: FC<TDebtsTableConfigProps> = ({ children }): JSX.Element => {
	const colorsMap = useGetDefaultColorsMap();
	const themeConfig = getAntdThemeConfig(colorsMap);

	return (
		<ConfigProvider
			{...themeConfig}
			theme={{
				components: {
					Input: {
						...themeConfig?.theme?.components?.Input,
						controlHeight: 36,
						fontSize: 14,
					},
					DatePicker: {
						...themeConfig?.theme?.components?.DatePicker,
						controlHeight: 36,
						fontSize: 14,
					},
					Select: {
						...themeConfig?.theme?.components?.Select,
						controlHeight: 36,
						fontSize: 14,
					},
					InputNumber: {
						...themeConfig?.theme?.components?.InputNumber,
						controlHeight: 38,
						fontSize: 14,
					},
				},
			}}
		>
			{children}
		</ConfigProvider>
	);
};
